module.exports = __webpack_public_path__ + "img/layout_right_6.0aab67b5.png";